import React from "react";
import {
  getAccountDetails,
  selectUser,
} from "../../../Redux/features/userSlice";
import { useAppDispatch, useAppSelector } from "../../../Redux/app/hooks";
import { SendOTP } from "../../../Apis/Auth/Account";
import AuthPageLayout from "../../../Components/Layouts/AuthPageLayout";
import { AuthRedirectionLink, FormContainer } from "../styles";
import TextInputWithIcon from "../../../Components/Form/Inputs/TextInputWithIcon";
import { CiUser } from "react-icons/ci";
import BigButton from "../../../Components/Form/Buttons/BigButton";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const _2FA = () => {
  const { username, logingUser } = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { name, value } = e.target;
    dispatch(getAccountDetails({ name, value }));
  };

  const handleSubmit = () => {
    if (username) {
      SendOTP(username, navigate, "/login");
    } else {
      toast.error("Please enter your username to proceed");
    }
  };

  return (
    <AuthPageLayout authText="2FA">
      <FormContainer>
        <TextInputWithIcon
          type="text"
          placeholder="Enter Username"
          icon={<CiUser />}
          value={username}
          name="username"
          handleChange={handleOnChange}
        />
        <BigButton
          buttonText="Send OTP"
          disabled={false}
          handleClick={handleSubmit}
          loading={logingUser}
        />
      </FormContainer>
      <AuthRedirectionLink to="/reset-password/2FA">
        Reset Password
      </AuthRedirectionLink>
    </AuthPageLayout>
  );
};

export default _2FA;
